import React from 'react';
import { includes } from 'lodash';
import cx from 'classnames';
import Modal from '../../../../../components/Modal';
import Table from '../../../../../components/table/Table';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import WidgetItemListWrap from '../../WidgetItemListWrap';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';
import {
  WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL,
  WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/widget/models';
import {
  SEARCH_PRODUCT_LIST_TABLE_EMPTY_TEXT,
  SELECTED_SEARCH_PRODUCT_LIST_TABLE_EMPTY_TEXT,
} from '../../../../../constants/service/app/widgetConstants';
import { columns } from './columns';
import './SearchProductListModal.scss';

const SearchProductListModal = (props) => {
  const {
    isOpen,
    closeModal,
    onSubmit,
    getProductList,
    data,
    onCheckProduct,
    mainProductCategorySelectList,
    subProductCategorySelectList,
    selectedProductList,
    selectedProductIdList,
    openImgViewModal,
    getProductSubCategoryList,
  } = props;
  const { listData, linkType } = data;
  const { list, filterOption, sortOption, pagination, summary = {} } = listData;

  return (
    <Modal
      title="상품 검색"
      isOpen={isOpen}
      width={1500}
      height={700}
      isFooter={true}
      onOk={() => onSubmit()}
      onClose={() => closeModal()}
    >
      <div className="search-product-list-modal-wrap">
        <WidgetItemListWrap title="선택된 상품">
          <Table
            className="selected-product-list-table"
            emptyText={SELECTED_SEARCH_PRODUCT_LIST_TABLE_EMPTY_TEXT}
            data={selectedProductList}
            sortable={false}
            defaultPageSize={1}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedProductIdList}
            onCheck={(list) => onCheckProduct(list)}
            columns={() =>
              columns({
                openImgViewModal,
                getProductSubCategoryList,
              })
            }
          />
        </WidgetItemListWrap>

        <WidgetItemListWrap title="상품 리스트">
          <TableWithSummary
            className="product-list-table"
            totalCnt={summary.totalCnt}
            emptyText={SEARCH_PRODUCT_LIST_TABLE_EMPTY_TEXT}
            initialOption={{
              filterOption: WIDGET_ITEM_LINK_ID_LIST_FILTER_OPTION_MODEL[linkType],
              sortOption: WIDGET_ITEM_LINK_ID_LIST_SORT_OPTION_MODEL[linkType],
              pagination: LIST_PAGINATION_MODEL,
            }}
            data={list}
            maxHeight={500}
            showPagination
            filterOption={filterOption}
            sortOption={sortOption}
            pagination={pagination}
            getList={getProductList}
            isUsedAllCheck={false}
            isUsedCheckbox={true}
            checkedIdList={selectedProductIdList}
            onCheck={(list) => onCheckProduct(list)}
            columns={(utils) =>
              columns({
                openImgViewModal,
                mainProductCategorySelectList,
                subProductCategorySelectList,
                getProductSubCategoryList,
                ...utils,
              })
            }
            getTdProps={(state, rowInfo) => {
              return {
                className: cx({ selected: includes(selectedProductIdList, rowInfo.original.id) }),
              };
            }}
          />
        </WidgetItemListWrap>
      </div>
    </Modal>
  );
};

export default SearchProductListModal;
